define("settings/controllers/groups/group/social_profiles/new", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/constants"], function (_exports, _asyncArrowRuntime, _controller, _object, _computed, _service, _tracking, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let NewController = _exports.default = (_dec = (0, _service.inject)('social/facebook-auth'), _dec2 = (0, _service.inject)('social/connect-profiles'), _dec3 = (0, _computed.readOnly)('auth.currentUserModel.hasValidLinkedinUserToken'), (_class = class NewController extends _controller.default {
    get numberOfSocialSetsInGroup() {
      return this.group.socialIdentities.length;
    }
    get selectedSocialIdentity() {
      return this.connectProfiles.selectedSocialIdentity;
    }
    get showFacebookSelector() {
      return this.connectProfiles.showFacebookSelector;
    }
    get showLinkedinSelector() {
      return this.show_linkedin_selector === 'true' ? true : false;
    }
    get showSocialSetSection() {
      return this.isAdmin || this.isMobileSubscription && this.hasRemainingSocialSets || !this.isMobileSubscription;
    }
    get isAdmin() {
      return this.auth.currentUserModel.admin;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get totalSocialSets() {
      return this.currentAccount.totalSocialSets;
    }
    get isPaid() {
      return this.subscriptions.isPaid;
    }
    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get canAddSocialSets() {
      return this.subscriptions.subscriptionPlan.canAddSocialSets;
    }
    get group() {
      return this.model;
    }
    get hasRemainingSocialSets() {
      return this.socialSetsRemaining > 0;
    }
    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }
    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || this.numberOfFreePlanSocialSets) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }
    get submitDisabled() {
      return this.selectedSocialProfile === null && this.selectedSocialProfileType === null;
    }
    get showFacebookLoginMessage() {
      return this.auth.currentAccount?.rolloutIgWithFbLoginOauth && this.selectedSocialProfileType === _constants.SOCIAL_PROFILE_CODES.INSTAGRAM;
    }
    constructor(owner) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      super(owner, ...args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor4, this);
      _defineProperty(this, "queryParams", ['show_linkedin_selector']);
      _defineProperty(this, "path", 'account.groups.group.social_profiles');
      _initializerDefineProperty(this, "hasFacebookSDK", _descriptor5, this);
      _initializerDefineProperty(this, "numberOfFreePlanSocialSets", _descriptor6, this);
      _initializerDefineProperty(this, "passedInSocialIdentityId", _descriptor7, this);
      _initializerDefineProperty(this, "selectedSocialProfile", _descriptor8, this);
      _initializerDefineProperty(this, "selectedSocialProfileType", _descriptor9, this);
      _initializerDefineProperty(this, "show_linkedin_selector", _descriptor10, this);
      _initializerDefineProperty(this, "hasValidLinkedinUserToken", _descriptor11, this);
      _defineProperty(this, "updateShowProfileProperty", (property, value) => {
        this.connectProfiles.updateProperty(property, value);
      });
      _defineProperty(this, "addLinkedinProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (id) {
          yield this.connectProfiles.addLinkedinProfile.perform({
            group: this.group,
            id,
            path: this.path
          });
        }
      }), null, "addLinkedinProfile", "drop"));
      _defineProperty(this, "addSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.connectProfiles.addSocialProfile.perform({
            selectedSocialProfileType: this.selectedSocialProfileType,
            group: this.group,
            area: 'settings',
            passedInSocialIdentityId: this.passedInSocialIdentityId
          });
        }
      }), null, "addSocialProfile", "restartable"));
      this.facebookAuth.loadFacebookSDK().then(() => {
        if (!this.isDestroyed) {
          this.set('hasFacebookSDK', true);
        }
      }, () => {
        if (!this.isDestroyed) {
          this.set('hasFacebookSDK', false);
        }
      });
    }
    selectSocialProfile(socialProfile) {
      this.set('selectedSocialProfile', socialProfile);
    }
    toggleSelect(_ref) {
      let {
        socialIdentity,
        platform
      } = _ref;
      this.connectProfiles.updateProperty('selectedSocialIdentity', socialIdentity);
      this.set('selectedSocialProfileType', platform);
      this.set('passedInSocialIdentityId', socialIdentity.id);
    }
    async addFacebookProfile(uid, token, scopes) {
      await this.connectProfiles.addFacebookProfile({
        group: this.group,
        uid,
        token,
        scopes,
        path: 'cluster.schedule.calendar'
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasFacebookSDK", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "numberOfFreePlanSocialSets", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 1;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "passedInSocialIdentityId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return undefined;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfileType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "show_linkedin_selector", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hasValidLinkedinUserToken", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addFacebookProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addFacebookProfile"), _class.prototype)), _class));
});